import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=bbc84d6c&scoped=true"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=bbc84d6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc84d6c",
  null
  
)

export default component.exports